import {createSelector} from '@ngrx/store';

import {selectTicketsModuleState, TICKET_COMMENT_TAGS_FEATURE_KEY} from '../reducers';

export const selectTicketCommentTagsState = createSelector(
  selectTicketsModuleState,
  (moduleState) => moduleState[TICKET_COMMENT_TAGS_FEATURE_KEY]
);

export const selectTicketCommentTagsEntities = createSelector(
  selectTicketCommentTagsState,
  (state) => state.entities
);

export const selectTicketCommentTags = createSelector(
  selectTicketCommentTagsEntities,
  (entities) => Object.values(entities)
);

/////////////////////////////////////////////////////////////////////////////////////////////////////////////// Errors

export const selectErrors = createSelector(
  selectTicketCommentTagsState,
  (state) => state.errors
);

/////////////////////////////////////////////////////////////////////////////////////////////////////// Loading States

export const isLoading = createSelector(
  selectTicketCommentTagsState,
  (state) => state.loading
);

export const isLoaded = createSelector(
  selectTicketCommentTagsState,
  (state) => state.loaded
);
